module.exports = (parcelRequire.load("kyRNs")).then(() => parcelRequire('8cAla'));